export default __webpack_public_path__ + "static/media/Snd_LowerQHelicopter.ea8da8df.mp3";